"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**Un digito decimal */
exports.digit = /\d/;
/**Un caracter de la A-Z, excluyendo la Ñ */
exports.char = /[A-Z]/;
/**Un caracter de la A-Z o cualquier digito, excluyendo la Ñ */
exports.alphanum = /[A-Z,\d]/;
/**Un caracter de la A-Z o cualquier digito, incluyendo la Ñ */
exports.alphanumEsp = /[A-Z,\d,Ñ]/;
/**Un caracter de la A-Z, incluyendo la Ñ */
exports.charEsp = /[A-Z,Ñ]/;
/**Return a regex that matches any of the given components */
function any() {
    var components = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        components[_i] = arguments[_i];
    }
    var sources = components.map(function (x) { return nonCap(x).source; });
    var sourceComb = sources.join("|");
    var combined = "(?:" + sourceComb + ")";
    return new RegExp(combined);
}
exports.any = any;
/**Concat regexes */
function seq() {
    var components = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        components[_i] = arguments[_i];
    }
    return nonCap(new RegExp(components.map(function (x) { return x.source; }).join("")));
}
exports.seq = seq;
/**Encaja un regex solo si el regex encaja con toda la cadena completa */
function exact(component) {
    return new RegExp("^" + component.source + "$");
}
exports.exact = exact;
/**Encaja con un numero entero dado un rango. El rango es inclusivo. El numero incluye zeros a la izquierda*/
function integerRange(start, end) {
    if (end < start)
        throw new Error("End debe de ser mayor o igual que start");
    if (start < 0)
        throw new Error("Rangos negativos no estan soportados");
    /**Divide un numero en digitos, los digitos mas significativos quedan al principio del arreglo */
    function splitDigits(n, digits) {
        var ret = [];
        var acum = n;
        for (var i = 0; i < digits; i++) {
            ret.push(acum % 10);
            acum = Math.floor(acum / 10);
        }
        return ret.reverse();
    }
    var digits = Math.ceil(Math.log10(end));
    var startDigits = splitDigits(start, digits);
    var endDigits = splitDigits(end, digits);
    var limitDigit = 0;
    for (var i = 0; i < digits; i++) {
        if (startDigits[i] != endDigits[i]) {
            limitDigit = i;
            break;
        }
    }
    var regs = [];
    //Regex para los iniciales:
    for (var i = -1; i < digits - limitDigit; i++) {
        var reg = "";
        var iDigit = (digits - 1) - i;
        var invalid = false;
        for (var j = 0; j < digits; j++) {
            var startDigit = startDigits[j];
            var endDigit = endDigits[j];
            if (j == iDigit) {
                if (j == limitDigit) {
                    if ((startDigit + 1) > (endDigit - 1)) {
                        invalid = true;
                    }
                    reg += "[" + (startDigit + 1) + "-" + (endDigit - 1) + "]";
                }
                else {
                    reg += "[" + (startDigit + 1) + "-9]";
                }
            }
            else if (j > iDigit) {
                reg += "[0-9]";
            }
            else {
                reg += "" + startDigit;
            }
        }
        if (!invalid) {
            regs.push(reg);
        }
    }
    for (var i = digits - limitDigit - 2; i >= -1; i--) {
        var ret = "";
        var iDigit = (digits - 1) - i;
        var invalid = false;
        for (var j = 0; j < digits; j++) {
            var startDigit = startDigits[j];
            var endDigit = endDigits[j];
            if (j == iDigit) {
                if (endDigit == 0) {
                    invalid = true;
                }
                ret += "[0-" + (endDigit - 1) + "]";
            }
            else if (j > iDigit) {
                ret += "[0-9]";
            }
            else {
                ret += "" + endDigit;
            }
        }
        if (!invalid) {
            regs.push(ret);
        }
    }
    return nonCap(new RegExp(regs.join("|")));
}
exports.integerRange = integerRange;
/**Encaja con un numero entero con ciertos digitos. El numero debe de incluir zeros a la izquierda */
function integer(digits) {
    return nTimes(exports.digit, digits);
}
exports.integer = integer;
/**Enclose a regex on a non capturing group */
function nonCap(component) {
    return new RegExp("(?:" + component.source + ")");
}
exports.nonCap = nonCap;
/**Enclose a regex on a capturing group */
function cap(component) {
    return new RegExp("(" + component.source + ")");
}
exports.cap = cap;
/**Enclose a regex on a zero or one non capturing group*/
function optional(component) {
    return new RegExp(nonCap(component).source + "?");
}
exports.optional = optional;
/**Enclose a regex on a zero or more repetition non capturing group */
function zeroOrMore(component) {
    return new RegExp(nonCap(component).source + "*");
}
exports.zeroOrMore = zeroOrMore;
/**Enclose a regex on a one or more repetition non capturing group */
function oneOrMore(component) {
    return new RegExp(nonCap(component).source + "+");
}
exports.oneOrMore = oneOrMore;
/**Match exactly N times */
function nTimes(component, times) {
    return new RegExp(nonCap(component).source + ("{" + times + "}"));
}
exports.nTimes = nTimes;
/**Match at least N times */
function atLeastNTimes(component, times) {
    return new RegExp(nonCap(component).source + ("{" + times + ",}"));
}
exports.atLeastNTimes = atLeastNTimes;
/**Match at least N times */
function rangeTimes(component, min, max) {
    return new RegExp(nonCap(component).source + ("{" + min + "," + max + "}"));
}
exports.rangeTimes = rangeTimes;
/**Return a regex that parses a list of items separated with the given separator.
 * For capturing also an empty list enclose the commas regex on an optional regex
 */
function commas(item, separator) {
    return seq(nonCap(item), zeroOrMore(seq(separator, item)));
}
exports.commas = commas;
/**Create a regex that matches the given string  */
function str(str) {
    return new RegExp(escapeRegExp(str));
}
exports.str = str;
function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
/**Create an array with a range of numbers */
function range(start, count, step) {
    if (step === void 0) { step = 1; }
    var ret = [];
    for (var i = start; i < start + (count * step); i += step) {
        ret.push(i);
    }
    return ret;
}
/**Return a regex that parses a neasted expression
 * @param allowZeroDepth True to generate a regex that matches any text without the enclosing characters, false to make required at least one pair of enclosing characters
*/
function neasted(start, end, maxDepth, allowZeroDepth) {
    if (start.length != 1)
        throw new Error("start should be a single character");
    if (end.length != 1)
        throw new Error("end should be a single character");
    start = escapeRegExp(start);
    end = escapeRegExp(end);
    var bodyCharSource = "[^" + start + end + "]";
    var bodyChar = new RegExp(bodyCharSource);
    var zeroDepth = nonCap(oneOrMore(bodyChar));
    var repeat = function (s, n) { return range(0, n).map(function (x) { return s; }).join(""); };
    var nDepth = function (n) {
        return n == 0 ? zeroDepth :
            nonCap(new RegExp(repeat(start + bodyCharSource + "*", n - 1) + start + bodyCharSource + "*" + end + repeat(bodyCharSource + "*" + end, n - 1)));
    };
    var minDepth = allowZeroDepth ? 0 : 1;
    var allDepths = range(minDepth, maxDepth + 1 - minDepth).map(function (i) { return nDepth(i); });
    var ret = any.apply(void 0, __spread(allDepths));
    return ret;
}
exports.neasted = neasted;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLHVCQUF1QjtBQUNWLFFBQUEsS0FBSyxHQUFHLElBQUksQ0FBQztBQUMxQiw0Q0FBNEM7QUFDL0IsUUFBQSxJQUFJLEdBQUcsT0FBTyxDQUFDO0FBQzVCLCtEQUErRDtBQUNsRCxRQUFBLFFBQVEsR0FBRyxVQUFVLENBQUM7QUFDbkMsK0RBQStEO0FBQ2xELFFBQUEsV0FBVyxHQUFHLFlBQVksQ0FBQztBQUN4Qyw0Q0FBNEM7QUFDL0IsUUFBQSxPQUFPLEdBQUcsU0FBUyxDQUFDO0FBR2pDLDZEQUE2RDtBQUM3RDtJQUFvQixvQkFBdUI7U0FBdkIsVUFBdUIsRUFBdkIscUJBQXVCLEVBQXZCLElBQXVCO1FBQXZCLCtCQUF1Qjs7SUFDdkMsSUFBTSxPQUFPLEdBQUcsVUFBVSxDQUFDLEdBQUcsQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLEVBQWhCLENBQWdCLENBQUMsQ0FBQztJQUN0RCxJQUFNLFVBQVUsR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ3JDLElBQU0sUUFBUSxHQUFHLEtBQUssR0FBRyxVQUFVLEdBQUcsR0FBRyxDQUFDO0lBQzFDLE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUNoQyxDQUFDO0FBTEQsa0JBS0M7QUFFRCxvQkFBb0I7QUFDcEI7SUFBb0Isb0JBQXVCO1NBQXZCLFVBQXVCLEVBQXZCLHFCQUF1QixFQUF2QixJQUF1QjtRQUF2QiwrQkFBdUI7O0lBQ3ZDLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxNQUFNLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxVQUFBLENBQUMsSUFBSSxPQUFBLENBQUMsQ0FBQyxNQUFNLEVBQVIsQ0FBUSxDQUFDLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUN0RSxDQUFDO0FBRkQsa0JBRUM7QUFFRCx5RUFBeUU7QUFDekUsZUFBc0IsU0FBaUI7SUFDbkMsTUFBTSxDQUFDLElBQUksTUFBTSxDQUFDLE1BQUksU0FBUyxDQUFDLE1BQU0sTUFBRyxDQUFDLENBQUM7QUFDL0MsQ0FBQztBQUZELHNCQUVDO0FBRUQsNkdBQTZHO0FBQzdHLHNCQUE2QixLQUFhLEVBQUUsR0FBVztJQUNuRCxFQUFFLENBQUMsQ0FBQyxHQUFHLEdBQUcsS0FBSyxDQUFDO1FBQUMsTUFBTSxJQUFJLEtBQUssQ0FBQyx5Q0FBeUMsQ0FBQyxDQUFDO0lBQzVFLEVBQUUsQ0FBQyxDQUFDLEtBQUssR0FBRyxDQUFDLENBQUM7UUFBQyxNQUFNLElBQUksS0FBSyxDQUFDLHNDQUFzQyxDQUFDLENBQUM7SUFFdkUsaUdBQWlHO0lBQ2pHLHFCQUFxQixDQUFTLEVBQUUsTUFBYztRQUMxQyxJQUFJLEdBQUcsR0FBYSxFQUFFLENBQUM7UUFDdkIsSUFBSSxJQUFJLEdBQUcsQ0FBQyxDQUFDO1FBQ2IsR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FBQztZQUM5QixHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksR0FBRyxFQUFFLENBQUMsQ0FBQztZQUNwQixJQUFJLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLEdBQUcsRUFBRSxDQUFDLENBQUM7UUFDakMsQ0FBQztRQUNELE1BQU0sQ0FBQyxHQUFHLENBQUMsT0FBTyxFQUFFLENBQUM7SUFDekIsQ0FBQztJQUVELElBQU0sTUFBTSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO0lBQzFDLElBQU0sV0FBVyxHQUFHLFdBQVcsQ0FBQyxLQUFLLEVBQUUsTUFBTSxDQUFDLENBQUM7SUFDL0MsSUFBTSxTQUFTLEdBQUcsV0FBVyxDQUFDLEdBQUcsRUFBRSxNQUFNLENBQUMsQ0FBQztJQUUzQyxJQUFJLFVBQVUsR0FBRyxDQUFDLENBQUM7SUFDbkIsR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FBQztRQUM5QixFQUFFLENBQUMsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUNqQyxVQUFVLEdBQUcsQ0FBQyxDQUFDO1lBQ2YsS0FBSyxDQUFDO1FBQ1YsQ0FBQztJQUNMLENBQUM7SUFFRCxJQUFJLElBQUksR0FBYSxFQUFFLENBQUM7SUFFeEIsMkJBQTJCO0lBQzNCLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxFQUFFLENBQUMsR0FBRyxNQUFNLEdBQUcsVUFBVSxFQUFFLENBQUMsRUFBRSxFQUFFLENBQUM7UUFDNUMsSUFBSSxHQUFHLEdBQUcsRUFBRSxDQUFDO1FBQ2IsSUFBTSxNQUFNLEdBQUcsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ2hDLElBQUksT0FBTyxHQUFHLEtBQUssQ0FBQztRQUNwQixHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDO1lBQzlCLElBQU0sVUFBVSxHQUFHLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUNsQyxJQUFNLFFBQVEsR0FBRyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDOUIsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLE1BQU0sQ0FBQyxDQUFDLENBQUM7Z0JBQ2QsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLFVBQVUsQ0FBQyxDQUFDLENBQUM7b0JBQ2xCLEVBQUUsQ0FBQyxDQUFDLENBQUMsVUFBVSxHQUFHLENBQUMsQ0FBQyxHQUFHLENBQUMsUUFBUSxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQzt3QkFDcEMsT0FBTyxHQUFHLElBQUksQ0FBQztvQkFDbkIsQ0FBQztvQkFFRCxHQUFHLElBQUksT0FBSSxVQUFVLEdBQUcsQ0FBQyxXQUFJLFFBQVEsR0FBRyxDQUFDLE9BQUcsQ0FBQztnQkFDakQsQ0FBQztnQkFBQyxJQUFJLENBQUMsQ0FBQztvQkFDSixHQUFHLElBQUksT0FBSSxVQUFVLEdBQUcsQ0FBQyxTQUFLLENBQUM7Z0JBQ25DLENBQUM7WUFDTCxDQUFDO1lBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsR0FBRyxNQUFNLENBQUMsQ0FBQyxDQUFDO2dCQUNwQixHQUFHLElBQUksT0FBTyxDQUFDO1lBQ25CLENBQUM7WUFDRCxJQUFJLENBQUMsQ0FBQztnQkFDRixHQUFHLElBQUksRUFBRSxHQUFHLFVBQVUsQ0FBQztZQUMzQixDQUFDO1FBQ0wsQ0FBQztRQUNELEVBQUUsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztZQUNYLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDbkIsQ0FBQztJQUNMLENBQUM7SUFFRCxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxNQUFNLEdBQUcsVUFBVSxHQUFHLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FBQztRQUNqRCxJQUFJLEdBQUcsR0FBRyxFQUFFLENBQUM7UUFDYixJQUFNLE1BQU0sR0FBRyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDaEMsSUFBSSxPQUFPLEdBQUcsS0FBSyxDQUFDO1FBQ3BCLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFLENBQUM7WUFDOUIsSUFBTSxVQUFVLEdBQUcsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2xDLElBQU0sUUFBUSxHQUFHLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUM5QixFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQztnQkFDZCxFQUFFLENBQUMsQ0FBQyxRQUFRLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztvQkFDaEIsT0FBTyxHQUFHLElBQUksQ0FBQztnQkFDbkIsQ0FBQztnQkFFRCxHQUFHLElBQUksU0FBTSxRQUFRLEdBQUcsQ0FBQyxPQUFHLENBQUM7WUFDakMsQ0FBQztZQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEdBQUcsTUFBTSxDQUFDLENBQUMsQ0FBQztnQkFDcEIsR0FBRyxJQUFJLE9BQU8sQ0FBQztZQUNuQixDQUFDO1lBQUMsSUFBSSxDQUFDLENBQUM7Z0JBQ0osR0FBRyxJQUFJLEVBQUUsR0FBRyxRQUFRLENBQUM7WUFDekIsQ0FBQztRQUNMLENBQUM7UUFDRCxFQUFFLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7WUFDWCxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ25CLENBQUM7SUFDTCxDQUFDO0lBRUQsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUM5QyxDQUFDO0FBcEZELG9DQW9GQztBQUVELHFHQUFxRztBQUNyRyxpQkFBd0IsTUFBYztJQUNsQyxNQUFNLENBQUMsTUFBTSxDQUFDLGFBQUssRUFBRSxNQUFNLENBQUMsQ0FBQztBQUNqQyxDQUFDO0FBRkQsMEJBRUM7QUFFRCw4Q0FBOEM7QUFDOUMsZ0JBQXVCLFNBQWlCO0lBQ3BDLE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxLQUFLLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxHQUFHLENBQUMsQ0FBQztBQUN0RCxDQUFDO0FBRkQsd0JBRUM7QUFFRCwwQ0FBMEM7QUFDMUMsYUFBb0IsU0FBaUI7SUFDakMsTUFBTSxDQUFDLElBQUksTUFBTSxDQUFDLEdBQUcsR0FBRyxTQUFTLENBQUMsTUFBTSxHQUFHLEdBQUcsQ0FBQyxDQUFDO0FBQ3BELENBQUM7QUFGRCxrQkFFQztBQUVELHlEQUF5RDtBQUN6RCxrQkFBeUIsU0FBaUI7SUFDdEMsTUFBTSxDQUFDLElBQUksTUFBTSxDQUFDLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQyxNQUFNLEdBQUcsR0FBRyxDQUFDLENBQUM7QUFDdEQsQ0FBQztBQUZELDRCQUVDO0FBRUQsc0VBQXNFO0FBQ3RFLG9CQUEyQixTQUFpQjtJQUN4QyxNQUFNLENBQUMsSUFBSSxNQUFNLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQyxDQUFDLE1BQU0sR0FBRyxHQUFHLENBQUMsQ0FBQztBQUN0RCxDQUFDO0FBRkQsZ0NBRUM7QUFFRCxxRUFBcUU7QUFDckUsbUJBQTBCLFNBQWlCO0lBQ3ZDLE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDLENBQUMsTUFBTSxHQUFHLEdBQUcsQ0FBQyxDQUFDO0FBQ3RELENBQUM7QUFGRCw4QkFFQztBQUVELDJCQUEyQjtBQUMzQixnQkFBdUIsU0FBaUIsRUFBRSxLQUFhO0lBQ25ELE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDLENBQUMsTUFBTSxJQUFHLE1BQUksS0FBSyxNQUFHLENBQUEsQ0FBQyxDQUFDO0FBQy9ELENBQUM7QUFGRCx3QkFFQztBQUVELDRCQUE0QjtBQUM1Qix1QkFBOEIsU0FBaUIsRUFBRSxLQUFhO0lBQzFELE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDLENBQUMsTUFBTSxJQUFHLE1BQUksS0FBSyxPQUFJLENBQUEsQ0FBQyxDQUFDO0FBQ2hFLENBQUM7QUFGRCxzQ0FFQztBQUVELDRCQUE0QjtBQUM1QixvQkFBMkIsU0FBaUIsRUFBRSxHQUFXLEVBQUUsR0FBVztJQUNsRSxNQUFNLENBQUMsSUFBSSxNQUFNLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQyxDQUFDLE1BQU0sSUFBRyxNQUFJLEdBQUcsU0FBSSxHQUFHLE1BQUcsQ0FBQSxDQUFDLENBQUM7QUFDcEUsQ0FBQztBQUZELGdDQUVDO0FBR0Q7O0dBRUc7QUFDSCxnQkFBdUIsSUFBWSxFQUFFLFNBQWlCO0lBQ2xELE1BQU0sQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLFVBQVUsQ0FBQyxHQUFHLENBQUMsU0FBUyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUMvRCxDQUFDO0FBRkQsd0JBRUM7QUFFRCxtREFBbUQ7QUFDbkQsYUFBb0IsR0FBVztJQUMzQixNQUFNLENBQUMsSUFBSSxNQUFNLENBQUMsWUFBWSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7QUFDekMsQ0FBQztBQUZELGtCQUVDO0FBRUQsc0JBQXNCLEdBQVc7SUFDN0IsTUFBTSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMscUNBQXFDLEVBQUUsTUFBTSxDQUFDLENBQUM7QUFDdEUsQ0FBQztBQUVELDZDQUE2QztBQUM3QyxlQUFlLEtBQWEsRUFBRSxLQUFhLEVBQUUsSUFBUTtJQUFSLHFCQUFBLEVBQUEsUUFBUTtJQUNqRCxJQUFNLEdBQUcsR0FBYSxFQUFFLENBQUM7SUFDekIsR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLEdBQUcsS0FBSyxFQUFFLENBQUMsR0FBRyxLQUFLLEdBQUcsQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFDLEVBQUUsQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDO1FBQ3hELEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDaEIsQ0FBQztJQUNELE1BQU0sQ0FBQyxHQUFHLENBQUM7QUFDZixDQUFDO0FBRUQ7O0VBRUU7QUFDRixpQkFBd0IsS0FBYSxFQUFFLEdBQVcsRUFBRSxRQUFnQixFQUFFLGNBQXVCO0lBQ3pGLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxNQUFNLElBQUksQ0FBQyxDQUFDO1FBQUMsTUFBTSxJQUFJLEtBQUssQ0FBQyxvQ0FBb0MsQ0FBQyxDQUFDO0lBQzdFLEVBQUUsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxNQUFNLElBQUksQ0FBQyxDQUFDO1FBQUMsTUFBTSxJQUFJLEtBQUssQ0FBQyxrQ0FBa0MsQ0FBQyxDQUFDO0lBRXpFLEtBQUssR0FBRyxZQUFZLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDNUIsR0FBRyxHQUFHLFlBQVksQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUV4QixJQUFNLGNBQWMsR0FBRyxPQUFLLEtBQUssR0FBRyxHQUFHLE1BQUcsQ0FBQztJQUMzQyxJQUFNLFFBQVEsR0FBRyxJQUFJLE1BQU0sQ0FBQyxjQUFjLENBQUMsQ0FBQztJQUM1QyxJQUFNLFNBQVMsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUM7SUFDOUMsSUFBTSxNQUFNLEdBQUcsVUFBQyxDQUFTLEVBQUUsQ0FBUyxJQUFLLE9BQUEsS0FBSyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxDQUFDLEVBQUQsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxFQUFoQyxDQUFnQyxDQUFDO0lBQzFFLElBQU0sTUFBTSxHQUFHLFVBQUMsQ0FBUztRQUNyQixPQUFBLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDO1lBQ2hCLE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsS0FBSyxHQUFHLGNBQWMsR0FBRyxHQUFHLEVBQUUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFHLEtBQUssR0FBRyxjQUFjLEdBQUcsR0FBRyxHQUFHLEdBQUcsR0FBRyxNQUFNLENBQUMsY0FBYyxHQUFHLEdBQUcsR0FBRyxHQUFHLEVBQUUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFEcEosQ0FDb0osQ0FBQztJQUd6SixJQUFNLFFBQVEsR0FBRyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ3hDLElBQU0sU0FBUyxHQUFHLEtBQUssQ0FBQyxRQUFRLEVBQUUsUUFBUSxHQUFHLENBQUMsR0FBRyxRQUFRLENBQUMsQ0FBQyxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQVQsQ0FBUyxDQUFDLENBQUM7SUFDL0UsSUFBTSxHQUFHLEdBQUcsR0FBRyx3QkFBSSxTQUFTLEVBQUMsQ0FBQztJQUU5QixNQUFNLENBQUMsR0FBRyxDQUFDO0FBQ2YsQ0FBQztBQXJCRCwwQkFxQkMifQ==


//////////////////
// WEBPACK FOOTER
// ./~/kea-regex/dist/index.js
// module id = 514
// module chunks = 0